import React from 'react';
import { CustomButton } from '../../../components';
import { Flex, Dropdown, type MenuProps, Space, Typography, Spin } from 'antd';
import shipmentCount from '@/assets/images/shipmentCount.svg';
import { ChevronDownIcon, PencilIcon } from '@/assets/icons/icons';
import { DownloadFormat } from '../types';

type Schedule = {
  id?: string | number;
  name?: string;
  description: string;
};
const { Text } = Typography;
interface DownloadFooterProps {
  setReportModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleDownload: (format: DownloadFormat) => void;
  // downloadFormat: DownloadFormat;
  // onFormatChange: (format: DownloadFormat) => void;
  totalRows?: number;
  loading?: boolean;
  schedules?: Schedule[];
  onCreateSchedule?: () => void;
  onEditSchedule?: (id: Schedule['id']) => void;
}

const DownloadReportFooter: React.FC<DownloadFooterProps> = ({
  setReportModalOpen,
  handleDownload,
  totalRows,
  loading,
  schedules,
  onCreateSchedule,
  onEditSchedule,
}) => {
  const handleFormatSelect = (format: DownloadFormat) => {
    handleDownload(format);
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'csv',
      label: 'CSV',
      disabled: false,
      onClick: () => handleFormatSelect('csv'),
    },
    {
      key: 'excel',
      label: 'XLSX',
      disabled: false,
      onClick: () => handleFormatSelect('excel'),
    },
    {
      key: 'pdf',
      label: 'PDF',
      disabled: true,
      onClick: () => handleFormatSelect('pdf'),
    },
  ];

  const scheduleMenuItems: MenuProps['items'] = (schedules || []).map((s) => ({
    key: String(s.id),
    label: (
      <div className='report-schedule-item'>
        <div>
          <div className='report-schedule-item-name'>{s.name}</div>
          <div className='report-schedule-item-description'>
            {s.description}
          </div>
        </div>
        <PencilIcon width={14} height={14} color='var(--text-primary)' />
      </div>
    ),
    onClick: () => onEditSchedule?.(s.id),
  }));

  return (
    <>
      <Flex className='download-report-footer' gap={16} align='center'>
        <Space className='report-download-summary'>
          <img src={shipmentCount} alt='shipment count' />
          <Text className='report-download-summary-text'>
            <span className='report-download-summary-count'>
              {totalRows} shipments records
            </span>{' '}
            will be downloaded{' '}
          </Text>
        </Space>
        <CustomButton
          text={'Cancel'}
          bgColor='transparent'
          color='var(--text-primary)'
          fontSize='14px'
          fontWeight='600'
          boxShadow='none'
          padding='0 12px'
          height='36px'
          onClick={() => setReportModalOpen(false)}
        />

        {schedules && schedules.length > 0 ? (
          <Dropdown
            menu={{ items: scheduleMenuItems }}
            trigger={['click']}
            dropdownRender={(menu) => {
              if (!React.isValidElement(menu)) {
                return menu;
              }

              const menuElement = menu as React.ReactElement<{
                style?: React.CSSProperties;
              }>;
              const clonedMenu = React.cloneElement(menuElement, {
                style: {
                  ...(menuElement.props.style || {}),
                  maxHeight: 'none',
                  overflowY: 'visible',
                },
              });

              return (
                <div className='report-schedule-dropdown'>
                  {' '}
                  <div className='report-schedule-dropdown-spacer' />
                  <div className='report-schedule-dropdown-scroll'>
                    <div
                      className='report-schedule-new'
                      onClick={() => onCreateSchedule?.()}
                    >
                      New
                    </div>

                    {clonedMenu}
                  </div>
                </div>
              );
            }}
          >
            <div className='report-action-trigger'>
              <CustomButton
                text={'Schedule'}
                bgColor='var(--text-primary)'
                color='var(--surface-container)'
                fontSize='14px'
                fontWeight='600'
                height='36px'
                borderRadius='8px'
                padding='0 32px'
                icon={<ChevronDownIcon color='var(--surface-container)' />}
                iconPosition='right'
                onClick={(e) => e.preventDefault()}
              />
            </div>
          </Dropdown>
        ) : (
          <CustomButton
            isFormValid={loading}
            text={'Schedule'}
            bgColor='var(--text-primary)'
            color='var(--surface-container)'
            fontSize='14px'
            fontWeight='600'
            height={'36px'}
            borderRadius='8px'
            padding='0 32px'
            onClick={() => onCreateSchedule?.()}
          />
        )}

        <Dropdown
          menu={{ items: menuItems }}
          trigger={['click']}
          disabled={loading}
        >
          <div className='report-action-trigger'>
            <CustomButton
              loader={loading ? <Spin size='small' /> : null}
              isFormValid={loading}
              text={`Download`}
              bgColor='var(--text-primary)'
              color='var(--surface-container)'
              fontSize='14px'
              fontWeight='600'
              height='36px'
              borderRadius='8px'
              padding='0 12px'
              iconPosition='right'
              icon={<ChevronDownIcon color='var(--surface-container)' />}
              onClick={(e) => e.preventDefault()}
            />
          </div>
        </Dropdown>
      </Flex>
    </>
  );
};

export default DownloadReportFooter;
